import "../Stylesheet/Certfication.css";
import { FiExternalLink } from "react-icons/fi";
import { BsAward } from "react-icons/bs";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { RiDoubleQuotesR } from "react-icons/ri";
import { useState, useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";


export default function Certification() {

    const { t, lang } = useContext(LanguageContext);
    const c = t.certification;

    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrev = () => {
        setCurrentIndex(
            currentIndex === 0 ? c.testimonials.length - 1 : currentIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex(
            currentIndex === c.testimonials.length - 1 ? 0 : currentIndex + 1
        );
    };

    return (
        <>
            <section className="cert-section">
                <div className="cert-header">
                    <h2 className={lang === "ta" ? "head-t" : "head-e"}>{c.title}</h2>
                    <p>{c.subtitle}</p>
                </div>

                <div className="cert-container">
                    {c.certificates.map((item, index) => (
                        <div className="cert-card" key={index}>
                            <div className="icon-wrap">
                                <BsAward />
                            </div>

                            <h3>{item.title}</h3>
                            <span>{item.org}</span>
                            <label>{item.year}</label>

                            <a href="/">{c.view}  <FiExternalLink /></a>
                        </div>
                    ))}
                </div>
            </section>

            {/* Testimonial section  */}

            <section className="testimonial-section">
                <div className="testimonial-container">

                    <h2 className={`testimonial-title ${lang === "ta" ? "title-t" : "title-e"}`}>{c.testimonialTitle}</h2>

                    <div className="testimonial-content">
                        <div className="quote-icon"><RiDoubleQuotesR /></div>
                        <div className="test">
                            <p className={`testimonial-text  slide ${lang === "ta" ? "text-t" : "text-e"}`}>
                                {c.testimonials[currentIndex].text}
                            </p>
                            <div className="testimonial-author">
                                <h4>{c.testimonials[currentIndex].name}</h4>
                                <span>{c.testimonials[currentIndex].role}</span>
                            </div>
                        </div>
                    </div>


                    <div className="testimonial-controls">
                        <button className="nav-btn" onClick={handlePrev}>
                            <FiChevronLeft />
                        </button>


                        <div className="dots">
                            {c.testimonials.map((_, index) => (
                                <span
                                    key={index}
                                    className={`dot ${index === currentIndex ? "active" : ""}`}
                                    onClick={() => setCurrentIndex(index)}
                                ></span>
                            ))}
                        </div>


                        <button className="nav-btn" onClick={handleNext}>
                            <FiChevronRight />
                        </button>


                    </div>

                </div>
            </section>
        </>
    );
}
